import { registerModule } from './store'
import { CreateRouterOptions } from '@/typings/common'


type Options = Required<CreateRouterOptions>

const createModule = (options: Options) => {
  registerModule(options)
  return []
}

export default createModule
